import { Title } from '@repo/foundations';
import { NavBarWrapper } from '.';

function ArchivePageNavBar() {
	return (
		<NavBarWrapper>
			<Title order={1} size="sm" data-testid="archive-page-nav-bar-title">
				Archived
			</Title>
		</NavBarWrapper>
	);
}

export default ArchivePageNavBar;
